import React, { useEffect, useState } from "react";
import { useUI } from "../../context/UIContext";
import { ReportAPI } from "../../api/apiClient";

interface PlantOutRow {
  component: string;
  date: string;
  quantity: number;
  unit: string;
}

export default function StatementEquipmentLatestPlantOutReport() {
  const { selectedProjectId } = useUI();
  const [data, setData] = useState<PlantOutRow[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selectedProjectId) return;

    const fetchDashboardData = async () => {
      try {
        setLoading(true);

        const result =
          await ReportAPI.getEquipmentLatestPlantOutDashboard({
            project: selectedProjectId,
            vendor: -1,
            cmp: 0,
          });

        setData(result);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [selectedProjectId]);

  // Combine quantity
  const totalQuantity = data.reduce(
    (sum, item) => sum + item.quantity,
    0
  );

  /*return (
    <div className="flex justify-center mt-10">

      {loading && <div>Loading...</div>}

      {!loading && data.length > 0 && (
        //<div className="w-[430px] rounded-xl shadow-md overflow-hidden bg-white">
        <div className="rounded-xl shadow-md overflow-hidden bg-white h-full">


          
          <div className="bg-blue-800 text-white px-4 py-3 text-sm font-semibold tracking-wide">
            RECENT PLANT-OUT
          </div>

         
          <div className="bg-gray-50 px-6 py-6">

            <div className="flex justify-between items-start text-sm">
              <div className="text-gray-800 font-medium">
                {data[0].component}
              </div>

              <div className="text-gray-500 text-xs">
                {new Date(data[0].date).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </div>
            </div>

            <div className="text-center mt-6 text-2xl font-semibold text-gray-700">
              {totalQuantity.toFixed(2)} {data[0].unit}
            </div>
          </div>
        </div>
      )}

      {!loading && data.length === 0 && (
        <div className="text-gray-500">No data available</div>
      )}
    </div>
  );
}*/
/*return (
  <>
    {loading && <div>Loading...</div>}

    {!loading && data.length > 0 && (
      <div className="rounded-xl shadow-md overflow-hidden bg-white h-full">

       
        <div className="bg-blue-800 text-white px-4 py-3 text-sm font-semibold tracking-wide">
          RECENT PLANT-OUT
        </div>

       
        <div className="bg-gray-50 px-6 py-6">

          <div className="flex justify-between items-start text-sm">
            <div className="text-gray-800 font-medium">
              {data[0].component}
            </div>

            <div className="text-gray-500 text-xs">
              {new Date(data[0].date).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </div>
          </div>

          <div className="text-center mt-6 text-2xl font-semibold text-gray-700">
            {totalQuantity.toFixed(2)} {data[0].unit}
          </div>
        </div>
      </div>
    )}

    {!loading && data.length === 0 && (
      <div className="text-gray-500">No data available</div>
    )}
  </>
);
}*/
/*return (
  <div className="rounded-xl shadow-md overflow-hidden bg-white h-full">

    
    <div className="bg-blue-800 text-white px-4 py-3 text-sm font-semibold tracking-wide">
      RECENT PLANT-OUT
    </div>

    
    <div className="bg-gray-50 px-6 py-6">

      {loading && (
        <div className="text-gray-500 text-sm">
          Loading...
        </div>
      )}

      {!loading && data.length === 0 && (
        <div className="text-gray-500 text-sm">
          No data found
        </div>
      )}

      {!loading && data.length > 0 && (
        <>
          <div className="flex justify-between items-start text-sm">
            <div className="text-gray-800 font-medium">
              {data[0].component}
            </div>

            <div className="text-gray-500 text-xs">
              {new Date(data[0].date).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </div>
          </div>

          <div className="text-center mt-6 text-2xl font-semibold text-gray-700">
            {totalQuantity.toFixed(2)} {data[0].unit}
          </div>
        </>
      )}

    </div>
  </div>
);
}*/

return (
  <div className="rounded-xl shadow-md overflow-hidden bg-white">

   {/* <div className="bg-blue-800 text-white px-4 py-3 text-sm font-semibold tracking-wide"> */}
      <div className="bg-[#1788ac] text-white px-4 py-3 text-sm font-semibold tracking-wide"> 
      RECENT PLANT-OUT
    </div>

    <div className="bg-gray-50 px-6 py-6">

      {loading && (
        <div className="text-gray-500 text-sm">
          Loading...
        </div>
      )}

      {!loading && data.length === 0 && (
        <div className="text-gray-500 text-sm">
          No data available
        </div>
      )}

      {!loading && data.length > 0 && (
        <>
          <div className="flex justify-between items-start text-sm">
            <div className="text-gray-800 font-medium">
              {data[0].component}
            </div>

            <div className="text-gray-500 text-xs">
              {new Date(data[0].date).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </div>
          </div>

          <div className="text-center mt-6 text-2xl font-semibold text-gray-700">
            {totalQuantity.toFixed(2)} {data[0].unit}
          </div>
        </>
      )}

    </div>
  </div>
);
}